<div class="modal-header">
  <h3>Verify Business Checks</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  @if (CompanyForm) {
    <form [formGroup]="CompanyForm">
      <div class="row align-items-start">
        @for (input of inputs; track input; let i = $index) {
          @if (input.show) {
            <div class="col-12">
              @if (input.inputType === 'checkBox' && input.formControl) {
                <div class="form-check-reverse">
                  <div class="row">
                    <div class="col-8 d-flex flex-column align-items-start">
                      <label
                        for="{{ input.label + i }}"
                        [ngbTooltip]="input.tooltip"
                        class="form-check-label"
                        >{{ input.label }}</label
                      >
                    </div>
                    <div class="col-2">
                      <input
                        id="{{ input.label + i }}"
                        type="checkbox"
                        class="form-check-input"
                        formControlName="{{ input.formControl }}"
                      />
                    </div>
                  </div>
                </div>
              }
              @if (input.inputType === 'text' && input.formControl) {
                <div class="form-group">
                  <div class="row">
                    <div class="col-8 d-flex flex-column align-items-start">
                      <label
                        for="{{ input.label + i }}"
                        [ngbTooltip]="input.tooltip"
                        class="form-label"
                        >{{ input.label }}</label
                      >
                    </div>
                    <div class="col-4">
                      <input
                        id="{{ input.label + i }}"
                        type="text"
                        class="form-control"
                        formControlName="{{ input.formControl }}"
                      />
                    </div>
                  </div>
                </div>
              }
              <!-- <div *ngIf="input.inputType === 'text' && !input.formControl" class="form-group">
                  <div class="row">
                    <div class="col-8 d-flex flex-column align-items-start">
                      <label for="{{ input.label + i }}" [ngbTooltip]="input.tooltip" class="form-label">{{ input.label }}</label>
                    </div>
                    <div class="col-4">
                      <input id="{{ input.label + i }}" type="text" class="form-control" formControlName="{{ input.formControl }}">
                    </div>
                  </div>
                </div> -->
            </div>
          }
        }
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
